module.exports = __webpack_public_path__ + "static/media/pie_chart_icon.547f2b06.svg";